const $ = require('jquery');

class CartOffscreenController {
    constructor($scope, $element, $timeout, shopPageStateService, sessionStorageWrapper) {
        this.$element = $element;
        this.$timeout = $timeout;
        this.shopPageStateService = shopPageStateService;
        this.sessionStorageWrapper = sessionStorageWrapper;

        $scope.$on('$stateChangeStart', () => this.toggleOpen(false));

        $scope.$watch(
            () => this.shopPageStateService.isCartOpen,
            () => this.toggleOpen(this.shopPageStateService.isCartOpen),
        );
    }

    $onInit() {
        // height to stick to the top
        // this is the height of the corporate header + category header which is
        // 30px + 50px = 80px
        this.stickyHeight = 80;

        this.$timeout(() => {
            this.shopPageStateService.isCartOpen = this.sessionStorageWrapper.getAndRemove('isCartOpen') === 'true';
        });
    }

    $postLink() {
        this.$cart = this.$element.find('.cartOffscreen');
        this.$mask = this.$element.find('.cartOffscreen-contentMask');

        $(window).on('beforeunload.cartpanel', () => this.sessionStorageWrapper.set('isCartOpen', this.shopPageStateService.isCartOpen));
    }

    $onDestroy() {
        $(window).off('beforeunload.cartpanel');
    }

    toggleOpen(open = !this.shopPageStateService.isCartOpen) {
        // This function sometimes gets called twice. Once by the ng-click from the template
        // and once by the watcher in the constructor. This is for performance reasons - if we always
        // wait for the watcher we have to wait 2 digest cycles which is slower on mobile devices.
        this.shopPageStateService.isCartOpen = open;

        this.shopPageStateService.toggleBodyScroll(!this.shopPageStateService.isCartOpen);
        this.$cart.toggleClass('is-open', this.shopPageStateService.isCartOpen);
        this.$mask.toggleClass('is-masked', this.shopPageStateService.isCartOpen);
    }
}

const cartOffscreenComponentDefinition = {
    controller: ['$scope', '$element', '$timeout', 'ShopPageStateService', 'SessionStorageWrapper', CartOffscreenController],
    template: require('./cart-offscreen.component.html').trim(),
};

module.exports = {
    CartOffscreenController,
    cartOffscreenComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/cart/cart-offscreen.component.js